import * as THREE from 'three';

export interface RGB {
  r: number;
  g: number;
  b: number;
}

const _color = new THREE.Color();

/**
 * Конвертирует PNL в RGB цвет (логарифмическая шкала как в оригинале)
 * Используем THREE.Color().setHSL() для корректного color management
 */
export const pnlToColor = (pnl: number, logMax: number): RGB => {
  const absPnl = Math.abs(pnl);
  const intensity = logMax > 0 ? Math.log(1 + absPnl) / logMax : 0;

  let h: number, s: number, l: number;

  if (pnl > 0) {
    h = 0.33 - intensity * 0.05;
    s = 0.7 + intensity * 0.3;
    l = 0.35 + intensity * 0.45;
  } else {
    h = 0.0 - intensity * 0.02;
    s = 0.7 + intensity * 0.3;
    l = 0.3 + intensity * 0.4;
  }

  _color.setHSL(h, s, l);
  return { r: _color.r, g: _color.g, b: _color.b };
};
